import { render } from "./dynamic-route.vue?vue&type=template&id=0524285a"
import script from "./dynamic-route.vue?vue&type=script&lang=js"
export * from "./dynamic-route.vue?vue&type=script&lang=js"
script.render = render

export default script